<template>
    <v-card tile>
        <v-tabs
        v-model="tab"
        background-color="primary"
        dark
        center-active
        show-arrows
        hide-slider
        >
            <v-tab>Contract</v-tab>
            <v-tab>Pool Details</v-tab>
            <v-tab>Assignees</v-tab>
            <v-tab>Images/Media</v-tab>
            <v-tab>Notes</v-tab>
            <v-tab>Equipment</v-tab>
            <v-tab>Warranty</v-tab>
            <v-tab>Issue Tracker</v-tab>
            <v-tab>Activity Log</v-tab>
        </v-tabs>

        <v-tabs-items touchless v-model="tab">
            <v-tab-item>
                <v-card flat tile class="primary">
                    <v-card-text>
                        <ValidationObserver ref="observer1">
                            <v-form ref="jobFields">
                                <v-list flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <ValidationProvider v-slot="{ errors }" name="Contract Type" rules="required">
                                                <v-select
                                                    v-model="form.job_type"
                                                    :items="job_types"
                                                    item-text="label"
                                                    item-value="value"
                                                    label="Contract Type"
                                                    required
                                                    :error-messages="errors"
                                                    @change="submit"
                                                    readonly
                                                ></v-select>
                                            </ValidationProvider>

                                            <v-text-field
                                                v-model="form.date"
                                                label="Contract Date"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>

                                            <ValidationProvider v-slot="{ errors }" name="Contract Amount" rules="required">
                                                <v-text-field
                                                    v-model="form.amount"
                                                    label="Contract Amount"
                                                    prefix="$"
                                                    required
                                                    :error-messages="errors"
                                                    readonly
                                                ></v-text-field>
                                            </ValidationProvider>

                                            <ValidationProvider v-slot="{ errors }" name="Status" rules="required">
                                                <v-select
                                                    v-model="form.status"
                                                    :items="filteredStatuses"
                                                    item-text="label"
                                                    item-value="value"
                                                    label="Status"
                                                    required
                                                    :error-messages="errors"
                                                    @change="submit"
                                                    readonly
                                                ></v-select>
                                            </ValidationProvider>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                </v-card>
                <v-card flat>
                    <v-card-text>
                        <ValidationObserver ref="observer1">
                            <v-form ref="personalform">
                                <v-list flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <ValidationProvider v-slot="{ errors }" name="First Name" rules="required">
                                                <v-text-field
                                                v-model="form.customer.object.first_name"
                                                :error-messages="errors"
                                                label="First Name"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Last Name" rules="required">
                                                <v-text-field
                                                v-model="form.customer.object.last_name"
                                                :error-messages="errors"
                                                label="Last Name"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Email" rules="required|email">
                                                <v-text-field
                                                v-model="form.customer.object.email"
                                                :error-messages="errors"
                                                label="E-mail"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Phone" rules="required">
                                                <v-text-field
                                                v-model="form.customer.object.phone"
                                                :error-messages="errors"
                                                label="Phone"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Street Address" rules="required">
                                                <v-text-field
                                                v-model="form.customer.object.street_address"
                                                :error-messages="errors"
                                                label="Street Address"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="City" rules="required">
                                                <v-text-field
                                                v-model="form.customer.object.city"
                                                :error-messages="errors"
                                                label="City"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="State" rules="required">
                                                <v-select
                                                    v-model="form.customer.object.state"
                                                    :items="states"
                                                    item-text="label"
                                                    item-value="value"
                                                    :error-messages="errors"
                                                    label="Select a State"
                                                    data-vv-name="state"
                                                    required
                                                ></v-select>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Zip Code" rules="required">
                                                <v-text-field
                                                v-model="form.customer.object.zip"
                                                :error-messages="errors"
                                                label="Zip Code"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn large min-width="100%" color="primary" tile @click="submit">Update</v-btn>
                    </v-card-actions>  
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat tile>
                    <v-card-text class="pa-0">
                        <ValidationObserver ref="observer2">
                            <v-tabs
                            v-model="tabjob"
                            background-color="accent"
                            centered
                            dark
                            icons-and-text
                            tile
                            >
                                <v-tabs-slider></v-tabs-slider>
                                <v-tab href="#tab-1">
                                    Options
                                    <v-icon>mdi-format-list-bulleted-square</v-icon>
                                </v-tab>
                                <v-tab href="#tab-2">
                                    Pool Data
                                    <v-icon>mdi-clipboard-list</v-icon>
                                </v-tab>
                            </v-tabs>

                            <v-tabs-items v-model="tabjob">
                                <v-tab-item
                                    value="tab-1"
                                >
                                    <v-card flat>                      
                                        <v-list two-line subheader flat>
                                            <v-list-item v-for="(option, index) in options" :key="index">
                                                <v-checkbox v-model="form.pooloptions" :value="option.id" :label="option.title" hide-details readonly></v-checkbox>
                                            </v-list-item>
                                        </v-list>
                                    </v-card>
                                </v-tab-item>
                                <v-tab-item
                                    value="tab-2"
                                >
                                    <v-card flat>                      
                                        <v-form>
                                            <v-list two-line subheader flat>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-select
                                                            v-model="form.size"
                                                            :items="sizes"
                                                            item-text="title"
                                                            item-value="id"
                                                            label="Select a Size"
                                                            data-vv-name="size"
                                                            @change="submit"
                                                            outlined
                                                            class="mt-3"
                                                            readonly
                                                        ></v-select>
                                                        <v-select
                                                            v-model="form.shape"
                                                            :items="shapes"
                                                            item-text="label"
                                                            item-value="value"
                                                            label="Select a Shape"
                                                            data-vv-name="shape"
                                                            @change="submit"
                                                            outlined
                                                            readonly
                                                        ></v-select>       
                                                        <v-text-field
                                                            v-model="form.deck_color"
                                                            label="Deck Color"
                                                            readonly
                                                        ></v-text-field>
                                                        <v-text-field
                                                            v-model="form.border_color"
                                                            label="Border Color"
                                                            readonly
                                                        ></v-text-field>
                                                        <v-text-field
                                                            v-model="form.waterfall_color"
                                                            label="Waterfall Color"
                                                            v-if="form.pooloptions && form.pooloptions.includes(9)"
                                                            readonly
                                                        ></v-text-field>                           
                                                        <v-select
                                                            v-model="form.pool_type"
                                                            :items="pool_types"
                                                            item-text="label"
                                                            item-value="value"
                                                            label="Pool Type"
                                                            outlined
                                                            readonly
                                                        ></v-select>
                                                        <v-text-field
                                                            v-model="form.liner_color"
                                                            label="Liner Color"
                                                            v-if="form.pool_type == 'liner'"
                                                            readonly
                                                        ></v-text-field>
                                                        <v-text-field
                                                            v-model="form.tile_selection"
                                                            label="Tile Selection"
                                                            v-if="form.pool_type == 'guinite'"
                                                            readonly
                                                        ></v-text-field>
                                                        <v-text-field
                                                            v-model="form.plaster"
                                                            label="Plaster"
                                                            v-if="form.pool_type == 'guinite'"
                                                            readonly
                                                        ></v-text-field>
                                                        <v-text-field
                                                            v-model="form.coping"
                                                            label="Coping"
                                                            v-if="form.pool_type == 'guinite'"
                                                            readonly
                                                        ></v-text-field>
                                                        <v-text-field
                                                            v-model="form.deck"
                                                            label="Deck"
                                                            v-if="form.pool_type == 'guinite'"
                                                            readonly
                                                        ></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-form>
                                    </v-card>
                                </v-tab-item>
                            </v-tabs-items>
                        </ValidationObserver>
                    </v-card-text>
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <ValidationObserver ref="observer2">
                            <v-form ref="jobDetailsForm">
                                <v-list flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <v-select
                                                v-model="form.users.admin"
                                                :items="users"
                                                item-text="name"
                                                item-value="id"
                                                label="Admin"
                                                clearable
                                                @change="submit"
                                                outlined
                                                readonly
                                            ></v-select>
                                            <v-select
                                                v-model="form.users.foreman"
                                                :items="users"
                                                item-text="name"
                                                item-value="id"
                                                label="Foreman"
                                                clearable
                                                @change="submit"
                                                outlined
                                                readonly
                                            ></v-select>
                                            <v-select
                                                v-model="form.users.salesperson"
                                                :items="users"
                                                item-text="name"
                                                item-value="id"
                                                label="Salesperson"
                                                clearable
                                                @change="submit"
                                                outlined
                                                readonly
                                            ></v-select>
                                            <v-select
                                                v-model="form.users.technician"
                                                :items="users"
                                                item-text="name"
                                                item-value="id"
                                                label="Service Technician"
                                                clearable
                                                @change="submit"
                                                outlined
                                                readonly
                                            ></v-select>
                                            <v-select
                                                v-model="form.users.cleaner"
                                                :items="users"
                                                item-text="name"
                                                item-value="id"
                                                label="Cleaner"
                                                clearable
                                                @change="submit"
                                                outlined
                                                readonly
                                            ></v-select>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text> 
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat tile>
                    <v-combobox
                        filled
                        v-model="mcat"
                        :items="media_categories"
                        item-text="label"
                        item-value="value"
                        label="Media Category"
                        hide-details
                    ></v-combobox>                   
                    <file-pond
                        v-if="mcat.value"
                        name="filepond"
                        ref="filepond"
                        label-idle='Drag & Drop your files or <span class="filepond--label-action"> Browse </span>'
                        v-bind:allow-multiple="true"
                        v-bind:allowImagePreview="false"
                        accepted-file-types="image/jpeg, image/png"
                        :server="{
                            url: 'https://api.mrpoolal.com/api/crm/job/image?id='+id+'&category='+mcat.value,
                            process: {
                                headers: {
                                    'Authorization': `Bearer ${token}`
                                }
                            }
                        }"
                        v-bind:files="files"
                        v-on:init="handleFilePondInit"
                        v-on:processfile="handleFilePondProcessfile"
                        class="mb-0"
                        />
                </v-card>
                 <template>
                    <v-card flat tile class="pa-0">
                        <v-card-text class="ma-0 pa-0">
                            <vue-picture-swipe :items="imgitems"></vue-picture-swipe>
                        </v-card-text>
                    </v-card>
                </template>
            </v-tab-item>
            <v-tab-item>                
                <Comment v-for="(comment, index) in form.comments" :key="index" :item="comment" @set-parent="replyComment"/>
                <v-divider></v-divider>
                <v-card flat tile class="comment-form">
                    <v-card-text>
                        <v-form ref="commentform">
                            <v-chip
                            v-if="comment.parent"
                            class="mb-3"
                            close
                            @click:close="comment.parent = null"
                            small
                            >
                                Replying to: {{ activeComment | truncate(20, '...') }}
                            </v-chip>
                            <tiptap-vuetify
                                class="mt-4"
                                v-model="comment.comment"
                                :extensions="extensions"
                                placeholder=""
                            />
                            <v-checkbox
                                v-model="comment.public"
                                v-if="comment.parent == null"
                                label="Make Public & Notify Customer"
                                hide-details
                                class="mt-1 public"
                                ripple="false"
                            ></v-checkbox>
                        </v-form>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="admin-action">
                        <v-spacer></v-spacer>
                        <v-btn large text tile elevation="0" @click="sendComment" :loading="loading">Submit</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions> 
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat tile>
                    <Equipments />
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat tile>
                    <Warranty />
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat tile>
                    <Issues />
                </v-card>
            </v-tab-item>
            <v-tab-item>
                <v-card flat tile>
                    <template v-for="(activity, index) in form.activities">
                        <v-list-item two-line :key="index" :class="activity.properties.type">
                            <v-list-item-content>
                                <v-list-item-title>{{ activity.description }}</v-list-item-title>
                                <v-list-item-subtitle>{{ activity.created_at }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider
                        :key="index + 'divider'"
                        ></v-divider>
                    </template>
                 </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import axios from 'axios'
import Comment from '../components/Comment.vue'
import Equipments from '../components/Jobs/Equipments.vue'
import Warranty from '../components/Jobs/Warranty.vue'
import Issues from '../components/Jobs/Issues.vue'
import { TiptapVuetify, Link, Image } from 'tiptap-vuetify'
import VuePictureSwipe from 'vue-picture-swipe';

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    props: ['token'],
    data () {
        return {
            voptions: { "inline": false, "button": true, "navbar": false, "title": false, "toolbar": true, "tooltip": false, "movable": false, "zoomable": true, "rotatable": false, "scalable": false, "transition": false, "fullscreen": false, "keyboard": false, "url": "data-source" },
            // declare extensions you want to use
            extensions: [
                Link,
                Image,
            ],
            tab: null,
            tabjob: null,
            files: [],
            uploadedFiles: [],
            form: {
                customer: {
                    label: '',
                    value: '',
                    object: []
                },
                status: '',
                date: new Date().toISOString().substr(0, 10),
                amount: '',
                job_type: '',
                size: '',
                shape: '',
                pool_type: '',
                users: {
                    admin: '',
                    foreman: '',
                    salesperson: '',
                    technician: '',
                    cleaner: ''
                },
                pooloptions: [],
                liner_color: '',
                tile_selection: '',
                plaster: '',
                coping: '',
                deck: '',
                deck_color: '',
                border_color: '',
                waterfall_color: '',
                images: [],
                comments: [],
                activities: []      
            },
            loading: false,
            comment: {
                comment: '',
                public: false,
                parent: null,
                type: 'comment'
            },
            isLoading: false,
            search: null,
            customers: [],
            job_types: [
                { label: 'New Construction', value: 'new_construction' },
                { label: 'Vynil Completed', value: 'vynil_completed' },
            ],
            pool_types: [
                { label: 'Liner Pool', value: 'liner' },
                { label: 'Guinite', value: 'guinite' },
            ],
            shapes: [
                { label: 'Rectangle', value: 'rectangle' },
                { label: 'Roman End', value: 'roman_end' },
                { label: 'Oasis', value: 'oasis' },
                { label: 'Capitol', value: 'capitol' },
                { label: 'Grecian', value: 'grecian' },
                { label: 'Rectangle L', value: 'rectangle_l' },
            ],
            media_categories: [
                { label: 'All', value: '' },
                { label: 'Cat 1', value: 1 },
                { label: 'Cat 2', value: 2 },
            ],
            yesno: [
                { label: 'Yes', value: 'yes' },
                { label: 'No', value: 'no' },
            ],
            mcat: {
                label: '',
                value: ''
            },
            mapKey: 0,
        }
    },
    async created() {
        await this.settoken(this.token)
        await this.getJob()
        console.log('test')
    },
    mounted() {
        if(this.$route.params.tab != '') {
            this.tab = this.$route.params.tab
        } 
    },
    watch: {
      search (val) {
        // Items have already been requested
        if (this.isLoading) return

        this.isLoading = true

        axios.get('crm/customers/search', {
            params: {
                keyword: val
            }
        })
        .then(response => {
            this.customers = response.data.customers
            this.$nextTick()
        })
        .catch(err => {
            console.log(err)
        })
        .finally(() => (this.isLoading = false))
      },
    },
    computed: {
        ...mapGetters({
            statuses: 'data/jobStatusArray',
            measurement_types: 'data/measurement_types',
            users: 'data/users',
            options: 'data/options',
            sizes: 'data/sizes',
        }),
        filteredStatuses() {
            return this.statuses.filter(status => {
                return status.value != 'all'
            })
        },
        activeComment() {
            let active = this.form.comments.filter(comment => {
                return comment.id == this.comment.parent
            })

            if(active.length > 0) {
                return active[0].comment
            } else {
                return ''
            }
        },
        filteredImages() {
            if(this.mcat.value) {
                return this.form.images.filter(image => {
                    return image.category == this.mcat.value
                })
            } else {
                return this.form.images
            }
        },
        imgitems() {
            var arr = [];
        
            this.filteredImages.forEach(function(item) {
                var img = {}; 
                img ["src"] = 'https://api.mrpoolal.com/img/crmjobs/'+item.image+'?w=1200&h=800&fit=crop';
                img ["thumbnail"] = 'https://api.mrpoolal.com/img/crmjobs/'+item.image+'?w=400&h=400&fit=crop';
                img ["w"] = 1200; // you modify it's properties
                img ["h"] = 800; // you modify it's properties

                arr.push(img); // you push it to the array
            });   

            return arr         
        }
    },
    components: {
        ValidationProvider,
        ValidationObserver,
        Comment,
        Issues,
        Equipments,
        Warranty,
        TiptapVuetify,
        'vue-picture-swipe': VuePictureSwipe,
    },
    methods: {
        ...mapActions({
            settoken: 'auth/attempt',
            updateJob: 'data/updateJob',
            addComment: 'data/addJobComment'
        }),
        getJob() {
            this.loading = true
            axios.get('crmcustomer/jobs/get')
                .then((response) => {
                    this.loading = false
                    this.form = response.data
                    if(response.data.users == null) {
                        this.form.users = {
                            admin: '',
                            foreman: '',
                            salesperson: '',
                            technician: '',
                            cleaner: ''                                
                        }
                    }
                    this.customers.push({...this.form.customer})
                    this.$nextTick()
                })
        },
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1) {
                this.loading = true
                this.$set(this.form, 'id', this.id)
                this.updateJob(this.form).then(() => {
                    this.getJob()
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                }).catch(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    this.tab = 0
                }
            }
        },
        async sendComment() {
            this.addComment({
                id: this.id, 
                comment: this.comment.comment, 
                public: this.comment.public, 
                parent: this.comment.parent,
                type: this.comment.type
            }).then(response => {
                this.getJob()
                if(response.parent) {
                    let filteredComment = this.form.comments.filter(comment => {
                        return comment.id == response.parent
                    })

                    filteredComment[0].children.unshift(response)
                } else {
                    this.form.comments.unshift(response)
                }
                this.comment.comment = ''
                this.comment.public = false
                this.comment.parent = null
                this.$store.commit('SET_SNACKTYPE', 'green')
                this.$store.commit('SET_SNACK', 'Successfully saved')
            }).catch(() => {
                this.loading = false
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Failed to save your comment! Please try again.')
            })
        },
        replyComment(parent, type) {
            this.comment.parent = parent
            this.comment.type = type
            const el = this.$el.getElementsByClassName('comment-form')[0]

            if (el) {
                el.scrollIntoView({behavior: 'smooth'})                
                this.$nextTick(() => this.$refs.comment.$refs.input.focus())
            }
        },
        handleFilePondProcessfile: function (error, file) {
            if(this.form.images !== undefined)
                this.form.images.push(JSON.parse(file.serverId))  
                this.$nextTick()
        },
        test(data) {
            var reader = new FileReader();
            reader.readAsDataURL(data); 
            reader.onloadend = function() {
                var base64data = reader.result;                
                console.log(base64data);
            }
        },
        loaded(map) {
            //map.addImage('cat', 'http://admin.mrpoolal.com/img/flag-icon-png-19.jpg');
            map.addLayer({
                id: 'points',
                type: 'symbol',
                source: {
                    type: 'geojson',
                    data: {
                        type: 'FeatureCollection',
                        features: this.markers,
                    },
                },
                layout: {
                    'text-field': ['get', 'title'],
                    'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
                    'text-radial-offset': 0.5,
                    'text-justify': 'auto',
                    'icon-image': 'circle-15'
                },
            })
        },
        mouseEntered(map) {
            map.getCanvas().style.cursor = 'pointer'
        },
        mouseLeft(map) {
            map.getCanvas().style.cursor = ''
        },
        showPhotoSwipe (index) {
            this.isOpen = true
            this.$set(this.options, 'index', index)
        },
        hidePhotoSwipe () {
            this.isOpen = false
        }
    }
}
</script>

<style lang="sass" scoped>
.admin-action 
    background: #1976d2
    button 
        width: 100%
        background: #ffffff
        color: #1976d2
.row-action
    background: #000
    button 
        width: 100%
        background: #ffffff
        color: #000
.comment-actions 
    background: #dadada
</style>
<style lang="sass">
.repeater
    padding: 30px 20px
    background: #eee
    margin: 10px 0
    text-align: center
    border-radius: 5px

.filepond--root
    margin-bottom: 0

.filepond--drop-label
    &.filepond--drop-label 
        label
            font-family: 'Roboto'

.text--primary.comment-text 
    img
        max-width: 100%

.tiptap-vuetify-editor 
    img
        max-width: 100%

.tiptap-vuetify-image-upload-area-holder
    background-color: #003a6f
    height: 300px
    outline: 2px dashed #ffffff

svg.tiptap-vuetify-image-upload-area-holder__icon
    display: none!important

label.tiptap-vuetify-image-upload-area-holder 
    br
        display: none

.tiptap-vuetify-image-upload-area-holder 
    h3
        color: #fff

.v-application
    .v-dialog 
        .headline
            font-family: inherit!important
            text-transform: uppercase
            font-weight: 500
            font-size: 24px!important

        .v-card__actions
            background: #eee

            .v-btn
                width: 49%

.v-data-table
    .v-data-table-header-mobile
        display: none
    tr
        td
            font-size: 16px

            &.v-data-table__mobile-row:nth-child(2n)
                background: #f7f7f7

            &.v-data-table__mobile-row
                padding-left: 0

                .v-data-table__mobile-row__header
                    line-height: 48px
                    width: 40%
                    padding-left: 16px
                    border-right: 1px solid #eee

.viewer-toolbar
    >ul
        >li
            border-radius: 0

            &.viewer-one-to-one, &.viewer-reset, &.viewer-play 
                display: none!important

.my-gallery 
    display: grid
    grid-template-columns: auto auto auto auto

    figure
        margin: 0

    img
        max-width: 100%
        vertical-align: top

.v-input    
    width: 100%
</style>